import Loading from "../../../components/Common/Loading";

import Prefabs from "../Prefabs";
import {
    useDeleteScPrefabV2Mutation, useGetPrefabsInfosV2SCQuery,
    useGetScPrefabsListV2Query,
    useUpdateScPrefabV2Mutation
} from "../../../core/api/solitaire-prefab-api";
import {useCreateStateV2SCMutation} from "../../../core/api/solitaire-state-api";

function PrefabsSc(props) {

    const [updateUserState, updateUserStateResponse] = useCreateStateV2SCMutation();
    const [updatePrefab, updatePrefabResponse] = useUpdateScPrefabV2Mutation();
    const [deletePrefab, deletePrefabResponse] = useDeleteScPrefabV2Mutation();
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
        isFetching
    } = useGetPrefabsInfosV2SCQuery();

    return (
        <>
            <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >
                <Prefabs prefabsListReady={isSuccess}
                         prefabsList={data}
                         updateUserState={updateUserState}
                         updateUserStateResponse={updateUserStateResponse}
                         updatePrefab={updatePrefab}
                         updatePrefabResponse={updatePrefabResponse}
                         deletePrefab={deletePrefab}
                         deletePrefabResponse={deletePrefabResponse}
                         refetch={refetch}
                         game={props.game}
                />
            </Loading>

        </>
    );

}

export default PrefabsSc;
